import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { Link } from "react-router-dom";
import CollegeEdit from "./college-edit";
import CollegeAdd from "./college-add";
import EduPagination from "../edu-pagination/edu-pagination";
import { toast, Bounce } from "react-toastify";
import DeleteModal from "../edu-helper/delete-modal";

export default function CollegeListTable() {
  const [collegeData, setCollegeData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  let loginUser = JSON.parse(localStorage.getItem("user"));

  const [activateCollegeAdd, setActivateCollegeAdd] = useState(false);
  const [activateCollegeEdit, setActivateCollegeEdit] = useState(false);
  const [selectCollegeRow, setSelectCollegeRow] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [campusList, setCampusList] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [deleteid, setDeleteid] = useState();
  const [barcodeModalOpen, setBarcodeModalOpen] = useState(false);
  const [barcodeValue, setBarcodeValue] = useState("");
  const [barcodeFilename, setBarcodeFilename] = useState("barcode-image.jpg");

  let CollegeList = async () => {
    try {
      let response = await axios(
        `${baseUrl}/get_college/?per_page=${pageLimit}&page=${pageNumber}&campus=${selectedCampus}`,
        {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );
      if (response?.status === 200) {
        setTotalCount(response?.data?.count || 0);
        setCollegeData(response?.data?.data || []);
      } else {
        setTotalCount(0);
        setCollegeData([]);
      }
    } catch (error) {
      console.error("Error fetching college data:", error);
      setTotalCount(0);
      setCollegeData([]);
    }
  };

  let CampusList = async () => {
    try {
      let response = await axios(`${baseUrl}/get_campus/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setCampusList(response?.data?.data || []);
      } else {
        setCampusList([]);
      }
    } catch (error) {
      console.error("Error fetching campus data:", error);
      setCampusList([]);
    }
  };

  let deleteHandle = async (id) => {
    let response;
    try {
      response = await axios(`${baseUrl}/delete_college/${id}/`, {
        method: "DELETE",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
        toast.success("College deleted Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  let filterByCampusHandler = async (e) => {
    setSelectedCampus(e.target.value);
    setPageNumber(1);
    setForceUpdate(!forceUpdate);
  };

  const handleBarcodeClick = (barcodeUrl, blockName) => {
    setBarcodeValue(barcodeUrl);
    setBarcodeFilename(`${blockName || "college"}-barcode.jpg`);
    setBarcodeModalOpen(true);
    // Open modal via Bootstrap
    const modal = document.getElementById("college-qrcode-modal");
    if (modal) {
      window.$ && window.$(modal).modal
        ? window.$(modal).modal("show")
        : modal.classList.add("show");
    }
  };

  const handleBarcodeModalClose = () => {
    setBarcodeModalOpen(false);
    setBarcodeValue("");
    setBarcodeFilename("barcode-image.jpg");
  };

  const handleBarcodeDownload = () => {
    const link = document.createElement("a");
    link.href = barcodeValue;
    link.download = barcodeFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    try {
      (async function () {
        await CollegeList();
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
  }, [forceUpdate, pageNumber, pageLimit]);

  useEffect(() => {
    try {
      (async function () {
        if (campusList?.length === 0) {
          await CampusList();
        }
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
  }, []);

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar activeItem={"BusManagement"} /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Block List
              </h4>
              <Link
                role="button"
                className="blu-btn"
                data-bs-toggle="modal"
                data-bs-target="#addcollege"
                onClick={() => setActivateCollegeAdd(true)}
              >
                <i className="fa fa-plus me-2" />
                Add
              </Link>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Block List
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row justify-content-end">
                  <div className="col-lg-4">
                    <select
                      name="campus"
                      onChange={filterByCampusHandler}
                      className="form-select"
                      value={selectedCampus}
                    >
                      <option value="">
                        {selectedCampus === ""
                          ? "Select College"
                          : "Clear Select"}
                      </option>
                      {(campusList || []).map((arr) => {
                        return (
                          <option key={arr?.id} value={arr?.id}>
                            {arr.campus_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Block</th>
                      <th>Bar Code</th>
                      <th>College</th>
                      <th>Company</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(collegeData || []).map((arr, i) => {
                      return (
                        <tr key={arr.id}>
                          <td>{++i + pageLimit * (pageNumber - 1)}</td>
                          <td>
                            <span>{arr?.block_name}</span>
                          </td>
                          <td>
                            <img
                              src={arr?.bar_code_url}
                              width="125"
                              height="125"
                              alt={arr?.bar_code_name}
                              style={{ cursor: "pointer" }}
                              data-bs-toggle="modal"
                              data-bs-target="#college-qrcode-modal"
                              onClick={() =>
                                handleBarcodeClick(
                                  arr?.bar_code_url,
                                  arr?.block_name
                                )
                              }
                            />
                          </td>
                          <td>
                            <span>{arr?.campus_name}</span>
                          </td>
                          <td>
                            <span>{arr?.company_name}</span>
                          </td>
                          <td>
                            {(loginUser.user_type === "ADMIN_MANAGER" ||
                              loginUser?.user_type === "CLEANING_MANAGER") && (
                              <Link
                                role="button"
                                className="btn btn-outline-warning"
                                data-bs-toggle="modal"
                                data-bs-target="#editcollege"
                                onClick={() => {
                                  setActivateCollegeEdit(true);
                                  setSelectCollegeRow(arr);
                                }}
                              >
                                <i className="fa fa-edit" />
                              </Link>
                            )}
                            &nbsp;
                            <button
                              className="btn btn-outline-danger"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#deletemodal"
                              onClick={() => setDeleteid(arr?.id)}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <EduPagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  totalCount={totalCount}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <DeleteModal deleteHandle={deleteHandle} id={deleteid} />
      <CollegeEdit
        selectCollegeRow={selectCollegeRow}
        setForceUpdate={setForceUpdate}
        forceUpdate={forceUpdate}
        activateCollegeEdit={activateCollegeEdit}
        setActivateCollegeEdit={setActivateCollegeEdit}
      />
      <CollegeAdd
        setForceUpdate={setForceUpdate}
        forceUpdate={forceUpdate}
        activateCollegeAdd={activateCollegeAdd}
        setActivateCollegeAdd={setActivateCollegeAdd}
      />
      {/* Barcode Modal */}
      <div
        className="modal fade"
        id="college-qrcode-modal"
        tabIndex={-1}
        aria-labelledby="collegeQrcodeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleBarcodeModalClose}
              />
            </div>
            <div className="modal-body text-center">
              {barcodeValue && (
                <img
                  src={barcodeValue}
                  alt="Barcode"
                  className="img-fluid"
                  style={{ maxHeight: 400 }}
                />
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={handleBarcodeModalClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleBarcodeDownload}
              >
                Download Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
